import * as React from 'react';
import { LetterSection } from '../LetterSection/LetterSection.old';
import styles from './styles.module.styl';
export var Terms = function (_a) {
    var _b = _a.letters, letters = _b === void 0 ? [] : _b, termsByLetter = _a.termsByLetter;
    return (React.createElement("section", null,
        letters.length === 0 && React.createElement("p", { className: styles.noResults }, "No results"),
        letters.map(function (letter) { return (React.createElement(LetterSection, { letter: letter, terms: termsByLetter[letter] })); })));
};
